import { ref } from "vue"
import _signupStepsCommonProps from "../../foundation/js/configurations/_signupStepsCommonProps"
import SignupStepActions from "../../../../Features/Blocks/Newsletters/NewslettersSignup/SignupStepActions/SignupStepActions.vue"
import { useInputMask } from "../../composables/use-input-mask.composable"
import formSettings from "../CustomForm/settings"

export default {
  name: "ContactStepContent",
  props: _signupStepsCommonProps,
  components: {
    SignupStepActions,
  },
  setup(props) {
    const firstNameInput = ref(props.getNamedFieldInputData.firstname)
    const lastNameInput = ref(props.getNamedFieldInputData.lastname)
    const emailInput = ref(props.getNamedFieldInputData.email)
    const phoneInput = ref(props.getNamedFieldInputData.phone)
    const isCustomerInput = ref(props.getNamedFieldInputData.isCustomer)
    const showCPR = ref(props.getNamedFieldInputData.isCustomer ?? false)
    const cprInput = ref(props.getNamedFieldInputData.cpr)
    const postalCodeInput = ref(props.getNamedFieldInputData.postalCode)
    const { inputElement: cprInputElement, updateMaskedValue: updateCprMaskedValue } = useInputMask(formSettings.formats.cpr)

    const handleIsCustomerInput = (bool) => {
      isCustomerInput.value = bool
      showCPR.value = bool
    }

    const onCprBlur = (evt) => {
      cprInput.value = updateCprMaskedValue(evt)
    }

    return {
      firstNameInput,
      lastNameInput,
      emailInput,
      phoneInput,
      isCustomerInput,
      handleIsCustomerInput,
      showCPR,
      cprInput,
      postalCodeInput,
      cprInputElement,
      onCprBlur,
    }
  },
}
